import React from 'react';
import { Box, Stack, Typography, Chip } from '@mui/material';
import parse, { DOMNode } from 'html-react-parser';
import { neutral } from '_lex/_foundations/phxColors';
import { translate as t } from 'hooks/useTranslations';
import _ from 'lodash';
import PolicyContentHelper from 'views/App/Portal/Policy/_helpers/policyContentHelper';
import contentConversionHelper from '../../../helpers/contentConversionHelper';
import AttachmentBox from '../../AttachmentLibrary/_components/AttachmentBox';
import { AttachmentManual } from 'views/App/Portal/Policy/_types/manuals/draft';

const ContentPanel = ({
  id,
  label,
  date,
  index,
  title,
  titleNumber,
  content,
  isPolicyEdit,
  additionalStyles = {},
  attachments = [],
  manualId,
  editLevelTag,
  isEditLevelChanged = false,
}: {
  id?: string;
  label?: string;
  date?: string;
  index: number | string;
  title: string;
  titleNumber?: string;
  content: string;
  isPolicyEdit?: boolean;
  additionalStyles?: object;
  attachments?: AttachmentManual[];
  manualId: string;
  editLevelTag?: string;
  isEditLevelChanged?: boolean;
}) => (
  <Box
    id={id}
    sx={{
      backgroundColor: 'white',
      padding: 4,
      border: `1px solid ${neutral[200]}`,
      borderRadius: '6px',
      ...additionalStyles,
    }}
  >
    {label && (
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4, color: neutral[500] }}>
        <Typography sx={{ fontWeight: 500 }}>{label}</Typography>
        <Typography>{date}</Typography>
      </Box>
    )}
    {editLevelTag && (
      <Box sx={{ mb: 2 }}>
        <Chip
          label={t(`draftManuals.editLevelTag.${editLevelTag}`)}
          variant='outlined'
          color={isEditLevelChanged ? 'success' : 'neutral'}
          sx={{ textTransform: 'uppercase' }}
        />
      </Box>
    )}
    <Typography sx={{ fontSize: 18, fontWeight: 600, mb: 2 }}>
      {!_.isEmpty(titleNumber) && <span>{titleNumber}: </span>}
      {parse(title, {
        replace(node: DOMNode, i: number) {
          return PolicyContentHelper.handleContent(node, i);
        },
      })}
    </Typography>
    {!isPolicyEdit && (
      <Box sx={{ maxHeight: '50vh', overflowY: 'auto' }}>
        <Typography>
          {parse(content || '', {
            replace(node: DOMNode, ind: number) {
              return PolicyContentHelper.handleContent(node, ind);
            },
          })}
        </Typography>
      </Box>
    )}
    {attachments?.length > 0 && (
      <Box sx={{ mt: 2 }}>
        <Stack
          direction='row'
          spacing={1}
        >
          {attachments
            .filter((att) => !att.embedded)
            .map((att) => (
              <AttachmentBox
                key={`attachment-${att.id}`}
                attachmentRef={{ ...att, embedded: att.embedded ?? false }}
                manualId={manualId}
                onRemove={() => {}}
                isEditable={false}
              />
            ))}
        </Stack>
      </Box>
    )}
  </Box>
);

export default ContentPanel;
